<template>
  <div :class="['icon', sizeClass]">
    <svg :class="`icon--${icon}`">
      <use :xlink:href="`#icon-${icon}`"></use>
    </svg>
  </div>
</template>

<script>
export default {
  name: 'icon',
  props: {
    icon: {
      type: String,
    },
    size: {
      type: String,
    },
  },
  computed: {
    sizeClass() {
      return this.size ? `icon--size-${this.size}` : '';
    },
  },
};
</script>
